import { render, staticRenderFns } from "./ChatCallAvailabilityMessage.vue?vue&type=template&id=07fe9884&scoped=true&lang=pug"
import script from "./ChatCallAvailabilityMessage.vue?vue&type=script&lang=js"
export * from "./ChatCallAvailabilityMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatCallAvailabilityMessage.vue?vue&type=style&index=0&id=07fe9884&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fe9884",
  null
  
)

export default component.exports